/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAppCoreEnumsAuth0Roles } from './ControlAppCoreEnumsAuth0Roles';
import {
    ControlAppCoreEnumsAuth0RolesFromJSON,
    ControlAppCoreEnumsAuth0RolesFromJSONTyped,
    ControlAppCoreEnumsAuth0RolesToJSON,
} from './ControlAppCoreEnumsAuth0Roles';

/**
 * 
 * @export
 * @interface ControlInvite
 */
export interface ControlInvite {
    /**
     * 
     * @type {string}
     * @memberof ControlInvite
     */
    email: string;
    /**
     * 
     * @type {ControlAppCoreEnumsAuth0Roles}
     * @memberof ControlInvite
     */
    auth0_role: ControlAppCoreEnumsAuth0Roles;
}

/**
 * Check if a given object implements the ControlInvite interface.
 */
export function instanceOfControlInvite(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "auth0_role" in value;

    return isInstance;
}

export function ControlInviteFromJSON(json: any): ControlInvite {
    return ControlInviteFromJSONTyped(json, false);
}

export function ControlInviteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlInvite {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'auth0_role': ControlAppCoreEnumsAuth0RolesFromJSON(json['auth0_role']),
    };
}

export function ControlInviteToJSON(value?: ControlInvite | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'auth0_role': ControlAppCoreEnumsAuth0RolesToJSON(value.auth0_role),
    };
}

